import { ComponentStyleConfig } from '@chakra-ui/react';

export const QrWindow: ComponentStyleConfig = {
  parts: [
    'container',
    'wrapper',
    'logoImage',
    'qrWrapper',
    'qrImage',
    'listText',
    'listIcon',
  ],
  baseStyle: {
    container: {
      display: 'flex',
      overflow: 'auto',
      height: '100%',
      padding: 0,
      backgroundColor: 'surface2',
    },
    wrapper: {
      display: 'inline-flex',
      flexDirection: 'column',
      maxWidth: '280px',
      height: '543px',
      margin: 'auto',
      alignItems: 'center',
      width: '100%',
      padding: 6,
      border: '1px solid',
      borderColor: 'borderBase',
      borderRadius: 4,
    },
    logoImage: {
      width: 167,
      height: '30px',
      mb: 6,
      flex: '0 0 auto',
      color: 'M.70',
    },
    qrWrapper: {
      maxWidth: 232,
      maxHeight: 232,
      width: '100%',
      height: '100%',
      padding: 2,
      borderRadius: 4,
      bg: 'surface2',
    },
    qrImage: {
      width: '100%',
      objectFit: 'cover',
      padding: '12px',
      borderRadius: 4,
      backgroundColor: 'surface1',
      border: '1px solid',
      borderColor: 'borderBase',
    },
    listText: {
      fontSize: 'sm',
      lineHeight: '17px',
    },
    listIcon: {
      height: 8,
      width: 8,
      ml: 2,
    },
  },
  variants: {},
  sizes: {},
  defaultProps: {},
};
